import { Component, OnInit } from '@angular/core';
import { UilabBaseComponentsModule } from '@uilab/base-components-angular';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [UilabBaseComponentsModule],
})
export class FooterComponent implements OnInit {
    public copyrightYear!: string;

    public ngOnInit() {
        this.copyrightYear = new Date().getFullYear().toString();
    }

    link(dest: string) {
        window.location.href = dest;
    }

    internalLink(dest: string) {
        location.assign(dest);
    }
}
